import { app } from '../app';

app.config(config);

/** @ngInject */
function config($compileProvider, $sceDelegateProvider) {    
    var aHrefRegExpStr = '^\s*(https?|ftp|saaspass|saaspass-wa|' + window.env.urlSchemaWa + '|mailto|chrome-extension):';
	var aHrefRegExp = new RegExp(aHrefRegExpStr, 'g');
    $compileProvider.aHrefSanitizationWhitelist(aHrefRegExp);
    $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|ftp|saaspass|file|blob):|data:image\//);
    $sceDelegateProvider.resourceUrlWhitelist(['**']);
}



// WEBPACK FOOTER //
// ./src/portal/config/sanitize.config.js